import '@corbieres/scss/app-wpet-list.scss';
import '@corbieres/scss/app-wpet-list-agenda.scss';
import '@corbieres/scss/app-wpet-single.scss';
import '@corbieres/scss/app-wpet-single-agenda.scss';
import '@corbieres/scss/app-wpet-single-itinerary.scss';
import '@corbieres/scss/app-wpet-single-itinerary-pdf.scss';
import '@corbieres/scss/app-wpet-interactivemap.scss';
import WpetList from '@corbieres/js/wpet/list';
import WpetSingle from '@corbieres/js/wpet/single';
import WpetCrossSelling from '@corbieres/js/wpet/cross_selling';
import WpetInteractiveMap from '@corbieres/js/wpet/interactive-map';
import IcalComponent from '@corbieres/js/wpet/ICalComponent';

document.addEventListener( "DOMContentLoaded", function () {
    new WpetList();
    new WpetSingle();
    new WpetCrossSelling();
    new WpetInteractiveMap();

    if ($('#ics-calendar').length > 0) {
        new IcalComponent();
    }
} );
